module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAUUlEQVQ4y2P8//8/AyWAhYGBgeHGjRtkmaKhocHIgsQhSfONGzcYGBgYGJgYKAQs6AKMnfg1/C9H5VPsglEDBoMBLITimX4ugKVtUgEjpdkZAKwLEyFvJqG2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dataGrid/icon_checkbox_yes.png
// module id = 2025
// module chunks = 50